import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { navigate } from 'gatsby';

import { LocaleProvider } from '../core/Context/LocaleProvider';
import LinkGroup from '../core/LinkGroup';
import LinkGroupWithImages from '../core/LinkGroupWithImages';
import LinkWithImage from '../core/LinkWithImage';
import Image from '../core/Image';
import footerImage from '../../images/footer-image.svg';
import footerMobileImage from '../../images/mobile-footer.svg';
import {
  getIconLinks,
  getLocalizedLink,
  getLocalComponent,
  getTranslation,
} from '../../utils/helpers';

import {
  StyledFooter,
  FooterTop,
  FooterBottom,
  FooterLeft,
  FooterRight,
  FooterWave,
} from './styles';

const Footer = ({
  socialMediaLinks,
  footerLegalLinks,
  footerPrivoLogo,
  footerPrivacyUrl,
  footerNav,
  headingLevel,
  locales,
  locale,
  siteConfiguration,
}) => {
  const locale_footer = useContext(LocaleProvider);
  const { translations, brandLogoLink, brandLogo, copyright } =
    siteConfiguration;
  const countryCode = _.get(locale, 'code')
    ? _.get(locale, 'code').toUpperCase()
    : '';

  const localizedSocialMediaLinks = getLocalComponent(socialMediaLinks, locale);
  const localizedFooterLegalLinks = getLocalComponent(footerLegalLinks, locale);
  const localizedFooterPrivacyUrl = footerPrivacyUrl;
  const localizedFooterNav = getLocalComponent(footerNav, locale);

  let iconBlock;
  if (localizedSocialMediaLinks) {
    iconBlock = localizedSocialMediaLinks.map((mediaGroup) => {
      return (
        <LinkGroupWithImages
          key={mediaGroup.id}
          description={mediaGroup.title}
          links={getIconLinks(mediaGroup.components)}
          headingLevel={headingLevel}
        />
      );
    });
  }

  const localeSelectedLabel = getTranslation(
    'select_locale',
    translations,
    locale
  );

  console.log('localeSelectedLabel', translations);

  const buildBlock = (blocks, isVisible, displayStyle) => {
    return blocks.map((block) => {
      const { id, title, ariaLabel, components } = block;
      return (
        <LinkGroup
          key={id}
          title={title || ariaLabel || ''}
          titleVisible={isVisible}
          displayStyle={displayStyle}
          ariaLabel={ariaLabel}
          links={components}
          headingLevel={headingLevel}
        />
      );
    });
  };

  const localeSelector = () => {
    const supportedLocales = ['en-US', 'en-GB', 'nl-NL','fr-FR', 'fr-CA'];
    const localeData = locales.node_locale ? locales.node_locale : locales;
    const localeList = localeData.nodes
      .filter((loc) => supportedLocales.includes(loc.node_locale))
      .map((loc, i) => (
        <option
          key={`option-${loc.node_locale}-${i}`}
          // selected={loc.code === locale.code ? 'selected' : false}
          value={loc.node_locale}
        >
          {loc.node_locale.toUpperCase()}
        </option>
      ));
    return (
      <select
        aria-label={localeSelectedLabel}
        defaultValue={locales.node_locale}
        value={locale}
        onChange={(e) => {
          if (typeof window !== 'undefined') {
            navigate(
              window.location.pathname.split(locale).join(e.target.value)
            );
          }
        }}
      >
        {localeList}
      </select>
    );
  };

  console.log('footerLegalLinks', localizedFooterLegalLinks);
  console.log('footerPrivoLogo', localizedFooterPrivacyUrl);

  return (
    <StyledFooter>
      {/* <Image
        src={footerImage}
        alt=""
        role="presentation"
        preserveAspectRatio="xMinYMin none"
        imageSharp={{}}
        className="desktop-footer-img"
      /> */}
      <FooterWave img={footerImage} className="desktop-footer-img" />

      <Image
        src={footerMobileImage}
        alt=""
        role="presentation"
        imageSharp={{}}
        className="mobile-footer-img"
      />
      <div className="footer-wrapper">
        <div className="footer-container">
          {brandLogoLink && brandLogo && (
            <LinkWithImage
              linkURL={getLocalizedLink(`/${brandLogoLink.slug}`, locale_footer)}
              imgSrc=""
              imageSharp={brandLogo.gatsbyImage}
              altText={
                brandLogo.description ||
                brandLogo.title ||
                brandLogoLink.pageName ||
                ''
              }
            />
          )}
          <FooterTop>
            {localizedFooterNav && (
              <FooterLeft>
                {buildBlock([...localizedFooterNav], true, 'block')}
              </FooterLeft>
            )}
            {iconBlock && (
              <FooterRight className="footerRight socialBlock">
                {iconBlock}
              </FooterRight>
            )}
          </FooterTop>
          <FooterBottom>
            <FooterLeft className="footerLeft">
              {/* TODO implement language switcher */}
              <span className="language">{localeSelector(countryCode)}</span>
              {copyright && <span className="legal-text">{copyright}</span>}
            </FooterLeft>
            {localizedFooterLegalLinks && (
              <div className="terms-of-service-links">
                <FooterRight className="containertest">
                  <div className="privacylinks">
                    {buildBlock(localizedFooterLegalLinks, false, 'inline')}
                  </div>
                  <div className="cookiepref">
                    <a onClick={() => Optanon.ToggleInfoDisplay()}>
                      <span>Cookie Preferences</span>
                    </a>
                  </div>
                  {localizedFooterPrivacyUrl  && footerPrivoLogo &&(
                    <div className="privo privoDesktopView">
                      <LinkWithImage
                        linkURL={localizedFooterPrivacyUrl.externalLink}
                        imageSharp={footerPrivoLogo.gatsbyImage}
                        className="privoLogo"
                        altText={
                          localizedFooterPrivacyUrl.ariaLabel ||
                          ''
                        }
                      />
                    </div>
                  )}
                  
                </FooterRight>

                {localizedFooterPrivacyUrl  && footerPrivoLogo &&(
                    <div className="privo privoMobileView">
                      <LinkWithImage
                        linkURL={localizedFooterPrivacyUrl.externalLink}
                        imageSharp={footerPrivoLogo.gatsbyImage}
                        className="privoLogo"
                        altText={
                          localizedFooterPrivacyUrl.ariaLabel ||
                          ''
                        }
                      />
                    </div>
                  )}
                
              </div>
            )}
          </FooterBottom>
        </div>
      </div>
    </StyledFooter>
  );
};

export default Footer;
